<template>
  <section class="section-padding section-bg" id="section_2">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-12">
          <div class="custom-text-box">
            <template v-if="$i18n.locale == LANGUAGES.EN">
              <p><b>Privacy Policy</b></p>
              <p>Diverse Care Now</p>
              <p>
                Effective Date: March 2026<br />
                Last Updated: March 2026
              </p>

              <p>
                At Diverse Care Now, we are committed to protecting the privacy
                and confidentiality of our patients and website users. We comply
                with the Health Insurance Portability and Accountability Act of
                1996 (HIPAA) and all applicable federal and state privacy laws
                regarding the protection of your personal and health information.
              </p>

              <p><b>Information We Collect</b></p>
              <p>We may collect the following information when you use our services:</p>
              <ul>
                <li>Name</li>
                <li>Date of birth</li>
                <li>Address</li>
                <li>Telephone number</li>
                <li>Email address</li>
                <li>Insurance information (if applicable)</li>
                <li>Medical history</li>
                <li>Medication information</li>
                <li>Laboratory results</li>
                <li>Protected Health Information (PHI)</li>
                <li>Payment information</li>
                <li>Information submitted through our website, patient portal, or electronic forms</li>
              </ul>
              <p>
                We collect only the information necessary to provide healthcare
                services, process payments, communicate with you, and comply
                with legal requirements.
              </p>

              <p><b>How We Use Your Information</b></p>
              <p>Your information may be used to:</p>
              <ul>
                <li>Provide medical evaluation and treatment</li>
                <li>Coordinate your healthcare</li>
                <li>Process prescriptions and laboratory orders</li>
                <li>Schedule appointments</li>
                <li>Process billing and payments</li>
                <li>Communicate appointment reminders</li>
                <li>Respond to your questions</li>
                <li>Improve our services</li>
                <li>Comply with legal and regulatory requirements</li>
              </ul>
              <p>We will never sell your personal information.</p>

              <p><b>HIPAA Compliance</b></p>
              <p>
                Protected Health Information (PHI) is maintained in accordance
                with HIPAA Privacy and Security Rules.
              </p>
              <p>
                We use administrative, physical, and technical safeguards
                designed to protect your health information against
                unauthorized access, disclosure, alteration, or destruction.
              </p>
              <p>Only authorized personnel have access to your medical information.</p>

              <p><b>Disclosure of Information</b></p>
              <p>We may disclose your information only as permitted or required by law, including:</p>
              <ul>
                <li>Healthcare providers involved in your care</li>
                <li>Pharmacies</li>
                <li>Clinical laboratories</li>
                <li>Insurance companies (when applicable)</li>
                <li>Business associates who provide services on our behalf and are contractually required to maintain HIPAA compliance</li>
                <li>Government agencies when required by law</li>
              </ul>
              <p>
                We do not sell, rent, or share your personal information with
                third parties for advertising or marketing purposes.
              </p>

              <p><b>SMS, Email, and Telephone Communications</b></p>
              <p>By providing your contact information, you consent to receive communications from Diverse Care Now, including:</p>
              <ul>
                <li>Appointment reminders</li>
                <li>Prescription notifications</li>
                <li>Laboratory updates</li>
                <li>Billing notifications</li>
                <li>Care coordination</li>
                <li>Responses to your inquiries</li>
              </ul>
              <p>SMS consent is not shared with third parties or affiliates for marketing purposes.</p>
              <p>Standard message and data rates may apply.</p>
              <p>
                You may opt out of SMS communications at any time by replying
                STOP. Reply HELP for assistance or contact our office.
              </p>

              <p><b>Website Cookies</b></p>
              <p>
                Our website may use cookies and similar technologies to improve
                functionality and user experience.
              </p>
              <p>Cookies do not collect Protected Health Information unless voluntarily provided by you.</p>
              <p>You may disable cookies through your browser settings.</p>

              <p><b>Data Security</b></p>
              <p>We implement appropriate safeguards including:</p>
              <ul>
                <li>Secure electronic medical records</li>
                <li>Encrypted communications where appropriate</li>
                <li>Password-protected systems</li>
                <li>Access controls</li>
                <li>Secure data storage</li>
                <li>Regular security monitoring</li>
              </ul>
              <p>
                Although we use commercially reasonable safeguards, no
                electronic transmission or storage system can be guaranteed to
                be 100% secure.
              </p>

              <p><b>Your Rights</b></p>
              <p>Under HIPAA, you have the right to:</p>
              <ul>
                <li>Access your medical records</li>
                <li>Request corrections to your records</li>
                <li>Request restrictions on certain uses or disclosures</li>
                <li>Request confidential communications</li>
                <li>Obtain an accounting of certain disclosures</li>
                <li>Receive a copy of our Notice of Privacy Practices</li>
                <li>File a complaint without fear of retaliation</li>
              </ul>
              <p>To exercise these rights, please contact our office.</p>

              <p><b>Retention of Information</b></p>
              <p>
                Medical records are maintained in accordance with applicable
                federal and state laws regarding healthcare record retention.
              </p>

              <p><b>Third-Party Services</b></p>
              <p>
                Our website or patient portal may include links to third-party
                websites. Diverse Care Now is not responsible for the privacy
                practices of external websites.
              </p>

              <p><b>Children's Privacy</b></p>
              <p>
                Our services comply with applicable laws regarding the privacy
                of minors. Information regarding minors is collected only with
                appropriate parental or legal guardian authorization, as
                required by law.
              </p>

              <p><b>Changes to This Privacy Policy</b></p>
              <p>
                We reserve the right to update this Privacy Policy at any time.
                Updated versions will be posted on our website with the revised
                effective date.
              </p>
              <p>
                Continued use of our services constitutes acceptance of any
                revised Privacy Policy.
              </p>

              <p><b>Contact Information</b></p>
              <p>
                If you have questions regarding this Privacy Policy or wish to
                exercise your privacy rights, please contact:
              </p>
              <p>
                Diverse Care Now<br />
                2700 NE 14th Street, Suite 101<br />
                Pompano Beach, FL 33062<br />
                Phone: (754) 752-1888
              </p>
            </template>
            <template v-else-if="$i18n.locale == LANGUAGES.ES">
              <p><b>Política de Privacidad</b></p>
              <p>Diverse Care Now</p>
              <p>
                Fecha de entrada en vigor: Marzo de 2026<br />
                Última actualización: Marzo de 2026
              </p>

              <p>
                En Diverse Care Now, estamos comprometidos con proteger la
                privacidad y confidencialidad de nuestros pacientes y usuarios
                del sitio web. Cumplimos con la Ley de Portabilidad y
                Responsabilidad del Seguro Médico de 1996 (HIPAA) y con todas
                las leyes federales y estatales aplicables relacionadas con la
                protección de su información personal y de salud.
              </p>

              <p><b>Información que Recopilamos</b></p>
              <p>Podemos recopilar la siguiente información cuando utiliza nuestros servicios:</p>
              <ul>
                <li>Nombre</li>
                <li>Fecha de nacimiento</li>
                <li>Dirección</li>
                <li>Número de teléfono</li>
                <li>Correo electrónico</li>
                <li>Información del seguro (si corresponde)</li>
                <li>Historial médico</li>
                <li>Información sobre medicamentos</li>
                <li>Resultados de laboratorio</li>
                <li>Información de Salud Protegida (PHI)</li>
                <li>Información de pago</li>
                <li>Información enviada a través de nuestro sitio web, portal del paciente o formularios electrónicos</li>
              </ul>
              <p>
                Recopilamos únicamente la información necesaria para brindar
                servicios de salud, procesar pagos, comunicarnos con usted y
                cumplir con los requisitos legales.
              </p>

              <p><b>Cómo Usamos Su Información</b></p>
              <p>Su información puede ser utilizada para:</p>
              <ul>
                <li>Proporcionar evaluación y tratamiento médico</li>
                <li>Coordinar su atención médica</li>
                <li>Procesar recetas y órdenes de laboratorio</li>
                <li>Programar citas</li>
                <li>Procesar facturación y pagos</li>
                <li>Comunicar recordatorios de citas</li>
                <li>Responder a sus preguntas</li>
                <li>Mejorar nuestros servicios</li>
                <li>Cumplir con los requisitos legales y regulatorios</li>
              </ul>
              <p>Nunca venderemos su información personal.</p>

              <p><b>Cumplimiento de HIPAA</b></p>
              <p>
                La Información de Salud Protegida (PHI) se mantiene de acuerdo
                con las Reglas de Privacidad y Seguridad de HIPAA.
              </p>
              <p>
                Utilizamos salvaguardas administrativas, físicas y técnicas
                diseñadas para proteger su información de salud contra el
                acceso no autorizado, la divulgación, la alteración o la
                destrucción.
              </p>
              <p>Solo el personal autorizado tiene acceso a su información médica.</p>

              <p><b>Divulgación de Información</b></p>
              <p>Podemos divulgar su información solo según lo permitido o exigido por la ley, incluyendo:</p>
              <ul>
                <li>Proveedores de atención médica involucrados en su cuidado</li>
                <li>Farmacias</li>
                <li>Laboratorios clínicos</li>
                <li>Compañías de seguros (cuando corresponda)</li>
                <li>Asociados comerciales que prestan servicios en nuestro nombre y que están obligados por contrato a cumplir con HIPAA</li>
                <li>Agencias gubernamentales cuando lo exija la ley</li>
              </ul>
              <p>
                No vendemos, alquilamos ni compartimos su información personal
                con terceros con fines de publicidad o marketing.
              </p>

              <p><b>Comunicaciones por SMS, Correo Electrónico y Teléfono</b></p>
              <p>Al proporcionar su información de contacto, usted acepta recibir comunicaciones de Diverse Care Now, incluyendo:</p>
              <ul>
                <li>Recordatorios de citas</li>
                <li>Notificaciones de recetas</li>
                <li>Actualizaciones de laboratorio</li>
                <li>Notificaciones de facturación</li>
                <li>Coordinación de la atención</li>
                <li>Respuestas a sus consultas</li>
              </ul>
              <p>El consentimiento para SMS no se comparte con terceros ni afiliados con fines de marketing.</p>
              <p>Pueden aplicarse tarifas estándar de mensajes y datos.</p>
              <p>
                Puede optar por no recibir comunicaciones por SMS en cualquier
                momento respondiendo STOP. Responda HELP para obtener ayuda o
                comuníquese con nuestra oficina.
              </p>

              <p><b>Cookies del Sitio Web</b></p>
              <p>
                Nuestro sitio web puede utilizar cookies y tecnologías similares
                para mejorar la funcionalidad y la experiencia del usuario.
              </p>
              <p>Las cookies no recopilan Información de Salud Protegida a menos que usted la proporcione voluntariamente.</p>
              <p>Puede desactivar las cookies a través de la configuración de su navegador.</p>

              <p><b>Seguridad de los Datos</b></p>
              <p>Implementamos salvaguardas adecuadas que incluyen:</p>
              <ul>
                <li>Registros médicos electrónicos seguros</li>
                <li>Comunicaciones cifradas cuando corresponda</li>
                <li>Sistemas protegidos con contraseña</li>
                <li>Controles de acceso</li>
                <li>Almacenamiento seguro de datos</li>
                <li>Monitoreo de seguridad regular</li>
              </ul>
              <p>
                Aunque utilizamos salvaguardas comercialmente razonables, ningún
                sistema de transmisión o almacenamiento electrónico puede
                garantizarse como 100% seguro.
              </p>

              <p><b>Sus Derechos</b></p>
              <p>Bajo HIPAA, usted tiene derecho a:</p>
              <ul>
                <li>Acceder a sus registros médicos</li>
                <li>Solicitar correcciones a sus registros</li>
                <li>Solicitar restricciones sobre ciertos usos o divulgaciones</li>
                <li>Solicitar comunicaciones confidenciales</li>
                <li>Obtener un informe de ciertas divulgaciones</li>
                <li>Recibir una copia de nuestro Aviso de Prácticas de Privacidad</li>
                <li>Presentar una queja sin temor a represalias</li>
              </ul>
              <p>Para ejercer estos derechos, comuníquese con nuestra oficina.</p>

              <p><b>Retención de Información</b></p>
              <p>
                Los registros médicos se mantienen de acuerdo con las leyes
                federales y estatales aplicables sobre la retención de
                registros de salud.
              </p>

              <p><b>Servicios de Terceros</b></p>
              <p>
                Nuestro sitio web o portal del paciente puede incluir enlaces a
                sitios web de terceros. Diverse Care Now no es responsable de
                las prácticas de privacidad de sitios web externos.
              </p>

              <p><b>Privacidad de los Menores</b></p>
              <p>
                Nuestros servicios cumplen con las leyes aplicables relacionadas
                con la privacidad de los menores. La información sobre menores
                se recopila únicamente con la autorización adecuada de un padre
                o tutor legal, según lo requiera la ley.
              </p>

              <p><b>Cambios a Esta Política de Privacidad</b></p>
              <p>
                Nos reservamos el derecho de actualizar esta Política de
                Privacidad en cualquier momento. Las versiones actualizadas se
                publicarán en nuestro sitio web con la fecha de vigencia
                revisada.
              </p>
              <p>
                El uso continuado de nuestros servicios constituye la
                aceptación de cualquier Política de Privacidad revisada.
              </p>

              <p><b>Información de Contacto</b></p>
              <p>
                Si tiene preguntas sobre esta Política de Privacidad o desea
                ejercer sus derechos de privacidad, comuníquese con:
              </p>
              <p>
                Diverse Care Now<br />
                2700 NE 14th Street, Suite 101<br />
                Pompano Beach, FL 33062<br />
                Teléfono: (754) 752-1888
              </p>
            </template>
            <template v-else>
              <p><b>Política de Privacidade</b></p>
              <p>Diverse Care Now</p>
              <p>
                Data de Vigência: Março de 2026<br />
                Última Atualização: Março de 2026
              </p>

              <p>
                Na Diverse Care Now, estamos comprometidos em proteger a
                privacidade e a confidencialidade de nossos pacientes e
                usuários do site. Cumprimos com a Lei de Portabilidade e
                Responsabilidade de Seguros de Saúde de 1996 (HIPAA) e com
                todas as leis federais e estaduais aplicáveis relativas à
                proteção de suas informações pessoais e de saúde.
              </p>

              <p><b>Informações que Coletamos</b></p>
              <p>Podemos coletar as seguintes informações quando você utiliza nossos serviços:</p>
              <ul>
                <li>Nome</li>
                <li>Data de nascimento</li>
                <li>Endereço</li>
                <li>Número de telefone</li>
                <li>Endereço de e-mail</li>
                <li>Informações do seguro (se aplicável)</li>
                <li>Histórico médico</li>
                <li>Informações sobre medicamentos</li>
                <li>Resultados de laboratório</li>
                <li>Informações de Saúde Protegidas (PHI)</li>
                <li>Informações de pagamento</li>
                <li>Informações enviadas por meio de nosso site, portal do paciente ou formulários eletrônicos</li>
              </ul>
              <p>
                Coletamos apenas as informações necessárias para fornecer
                serviços de saúde, processar pagamentos, comunicar-nos com
                você e cumprir com os requisitos legais.
              </p>

              <p><b>Como Usamos Suas Informações</b></p>
              <p>Suas informações podem ser usadas para:</p>
              <ul>
                <li>Fornecer avaliação e tratamento médico</li>
                <li>Coordenar seus cuidados de saúde</li>
                <li>Processar receitas e pedidos de laboratório</li>
                <li>Agendar consultas</li>
                <li>Processar faturamento e pagamentos</li>
                <li>Comunicar lembretes de consultas</li>
                <li>Responder às suas perguntas</li>
                <li>Melhorar nossos serviços</li>
                <li>Cumprir com os requisitos legais e regulatórios</li>
              </ul>
              <p>Nunca venderemos suas informações pessoais.</p>

              <p><b>Conformidade com a HIPAA</b></p>
              <p>
                As Informações de Saúde Protegidas (PHI) são mantidas de
                acordo com as Regras de Privacidade e Segurança da HIPAA.
              </p>
              <p>
                Utilizamos salvaguardas administrativas, físicas e técnicas
                projetadas para proteger suas informações de saúde contra
                acesso não autorizado, divulgação, alteração ou destruição.
              </p>
              <p>Somente o pessoal autorizado tem acesso às suas informações médicas.</p>

              <p><b>Divulgação de Informações</b></p>
              <p>Podemos divulgar suas informações apenas conforme permitido ou exigido por lei, incluindo:</p>
              <ul>
                <li>Profissionais de saúde envolvidos em seus cuidados</li>
                <li>Farmácias</li>
                <li>Laboratórios clínicos</li>
                <li>Companhias de seguro (quando aplicável)</li>
                <li>Parceiros comerciais que prestam serviços em nosso nome e que são contratualmente obrigados a manter a conformidade com a HIPAA</li>
                <li>Órgãos governamentais quando exigido por lei</li>
              </ul>
              <p>
                Não vendemos, alugamos ou compartilhamos suas informações
                pessoais com terceiros para fins de publicidade ou marketing.
              </p>

              <p><b>Comunicações por SMS, E-mail e Telefone</b></p>
              <p>Ao fornecer suas informações de contato, você concorda em receber comunicações da Diverse Care Now, incluindo:</p>
              <ul>
                <li>Lembretes de consultas</li>
                <li>Notificações de receitas</li>
                <li>Atualizações de laboratório</li>
                <li>Notificações de faturamento</li>
                <li>Coordenação de cuidados</li>
                <li>Respostas às suas dúvidas</li>
              </ul>
              <p>O consentimento para SMS não é compartilhado com terceiros ou afiliados para fins de marketing.</p>
              <p>Taxas padrão de mensagens e dados podem ser aplicadas.</p>
              <p>
                Você pode cancelar as comunicações por SMS a qualquer momento
                respondendo STOP. Responda HELP para obter ajuda ou entre em
                contato com nosso escritório.
              </p>

              <p><b>Cookies do Site</b></p>
              <p>
                Nosso site pode usar cookies e tecnologias semelhantes para
                melhorar a funcionalidade e a experiência do usuário.
              </p>
              <p>Os cookies não coletam Informações de Saúde Protegidas, a menos que sejam fornecidas voluntariamente por você.</p>
              <p>Você pode desativar os cookies nas configurações do seu navegador.</p>

              <p><b>Segurança dos Dados</b></p>
              <p>Implementamos salvaguardas apropriadas, incluindo:</p>
              <ul>
                <li>Registros médicos eletrônicos seguros</li>
                <li>Comunicações criptografadas quando apropriado</li>
                <li>Sistemas protegidos por senha</li>
                <li>Controles de acesso</li>
                <li>Armazenamento seguro de dados</li>
                <li>Monitoramento regular de segurança</li>
              </ul>
              <p>
                Embora utilizemos salvaguardas comercialmente razoáveis, nenhum
                sistema de transmissão ou armazenamento eletrônico pode ser
                garantido como 100% seguro.
              </p>

              <p><b>Seus Direitos</b></p>
              <p>De acordo com a HIPAA, você tem o direito de:</p>
              <ul>
                <li>Acessar seus registros médicos</li>
                <li>Solicitar correções em seus registros</li>
                <li>Solicitar restrições sobre certos usos ou divulgações</li>
                <li>Solicitar comunicações confidenciais</li>
                <li>Obter um relatório de certas divulgações</li>
                <li>Receber uma cópia de nosso Aviso de Práticas de Privacidade</li>
                <li>Registrar uma reclamação sem medo de retaliação</li>
              </ul>
              <p>Para exercer esses direitos, entre em contato com nosso escritório.</p>

              <p><b>Retenção de Informações</b></p>
              <p>
                Os registros médicos são mantidos de acordo com as leis
                federais e estaduais aplicáveis relativas à retenção de
                registros de saúde.
              </p>

              <p><b>Serviços de Terceiros</b></p>
              <p>
                Nosso site ou portal do paciente pode incluir links para sites
                de terceiros. A Diverse Care Now não é responsável pelas
                práticas de privacidade de sites externos.
              </p>

              <p><b>Privacidade das Crianças</b></p>
              <p>
                Nossos serviços cumprem com as leis aplicáveis relativas à
                privacidade de menores. As informações referentes a menores são
                coletadas apenas com a autorização apropriada dos pais ou
                responsável legal, conforme exigido por lei.
              </p>

              <p><b>Alterações a Esta Política de Privacidade</b></p>
              <p>
                Reservamo-nos o direito de atualizar esta Política de
                Privacidade a qualquer momento. As versões atualizadas serão
                publicadas em nosso site com a data de vigência revisada.
              </p>
              <p>
                O uso contínuo de nossos serviços constitui a aceitação de
                qualquer Política de Privacidade revisada.
              </p>

              <p><b>Informações de Contato</b></p>
              <p>
                Se você tiver dúvidas sobre esta Política de Privacidade ou
                desejar exercer seus direitos de privacidade, entre em
                contato:
              </p>
              <p>
                Diverse Care Now<br />
                2700 NE 14th Street, Suite 101<br />
                Pompano Beach, FL 33062<br />
                Telefone: (754) 752-1888
              </p>
            </template>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { LANGUAGES } from '@/common/constants';

export default {
  name: "PrivacyPage",
  setup() {
    return {
      LANGUAGES
    };
  }
};
</script>
